// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__334D9","modalForm":"UpgradeEpcsModal_modalForm__2SfTa","modalFooter":"UpgradeEpcsModal_modalFooter__OM7n3"};